import {buildAuthInstance} from '.';

type AuthInstance = ReturnType<typeof buildAuthInstance>;
let clientAuthInstance: AuthInstance | undefined;
export const getClientAuthInstance = () => {
	// Rebuilds a new instance for each users on the server or
	if (!clientAuthInstance) {
		clientAuthInstance = buildAuthInstance(false);
	}
	return clientAuthInstance;
};
